import {uniqueId} from "lodash";

export default class MiniTableClass {
    defaultLayout = 0

    data = []

    sortableObj = null
    rowContainer
    mainContainer
    _settings = {
        addRow: true,
        addGroup: false,
        id: uniqueId(),
        layouts: [],
        showHeader: true,
    }

    constructor(layout, data, s ={}){
        // this.layout = layout
        if(layout.default != null){
            this.defaultLayout = layout.default
            this._settings.layouts = layout.layouts
        }else{

            this._settings.layouts = [layout]
        }
        this.data = data
        this.rowContainer = $('<div>').addClass('dataContainer container-fluid')
        this._settings = {...this._settings, ...s}

        this.mainContainer = $('<div>').addClass('mx-2 MiniTableContainer ')
            .append(this.createHeader())
            .append(this.rowContainer)
            .append(this.createFooter())
            .attr('id', this._settings.id)

        this.sortableObj = $(this.rowContainer[0]).sortable( {
            animation: 150,
            handle: '.reorderHandle',
            start: (a,b) => { },
            stop: (a,b) => {
                CS.updateSums()
            }
        })

        if(!data || data.length === 0) {
            // if(this._settings.addRow) this.addRow()
            // if(this._settings.addGroup) this.addRow()
        }else{
            $(data).each((i, elem) => {
                this.defaultLayout = elem._layout ?? this.defaultLayout
                this.addRow(elem) })
        }
        console.log('MT',this, layout)
    }

    layout(){
        return this._settings.layouts[this.defaultLayout]
    }

    getHTML(){

        return this.mainContainer
    }


    createHeader(){
        if(!this._settings.showHeader) return;
        let out = $('<div>')
            .addClass('rowContainer row')

        $(this.layout()).each((k, o) => {
            let cell = $('<div>')
                .append($('<div>').html(o.title))
                .addClass(o.class)
            if(o.subTitle)
                cell.append($('<div>').addClass('badge bg-dark').html(o.subTitle))

            out.append(cell)
        })

        return out;
    }



    createFooter(){
        let out = $('<div>')
            .addClass('rowContainer footer-row bg-white')



        let btnRow = $('<div>').addClass('row')


        for(let name in this._settings.layouts) {
            // if(name === '0') name = 'row'
            let addRowBtn = $('<span>')
                .addClass('btn-add-row col')
                .on('click', ()=> {
                    this.defaultLayout = name
                    this.addRow()
                })
                .html('<i class="fa-solid fa-plus col">Add '+ (name === '0' ? 'row' : name )+'</i>')

            btnRow.append(addRowBtn)
        }

        // let addGroupBtn = $('<span>')
        //     .addClass('btn-add-row row')
        //     .on('click', ()=> { this.addGroup()})
        //     .html('<i class="fa-solid fa-plus col">Add Group</i>')

        let sumRow = $('<div>')
            .addClass('sumRowContainer row border-top border-dark ')


        $(this.layout()).each( (k, o) => {
            let cell = $('<div>')
                // .append($('<div>').html('.'))
                .addClass(o.class)
            if(o.type === 'currency') {
                let x = $('<span>').addClass('subTotal total_'+o.name)
                cell.append(x)
            }
            sumRow.append(cell)

        })

        out.append(sumRow)
        if(this._settings.addRow) out.append(btnRow)
        // if(this._settings.addGroup) out.append(addGroupBtn)

        return out;
    }

    // addGroup(){
    //
    //     this.data.push({
    //         type: 'group',
    //         name: 'Group',
    //         rows: []
    //     })
    // }
    addRow(d={}){
        this.rowContainer.append(this.createRow(d))

        // if(this.sortableObj)
        //     this.sortableObj.refresh()
    }

    // createGroup(data){
    //     let out = $('<div>')
    //         .addClass('rowContainer row groupRow')
    //
    //     let title = $('<div>').html(data.name)
    //     out.append(title)
    //
    //
    //     return out
    // }
    createRow(data){
        let out = $('<div>')
            .addClass('rowContainer row dataRow')

        $(this.layout()).each(function (){
            let c = CS.createCol(data, this)
            out.append(c)
        })

        out.append($('<input>').attr({'name': '_layout', 'type':'hidden', 'value':this.defaultLayout}))


        return out
    }
}
